import { ApiUtility } from "./ApiUtility";

class PravachansService {
  pravachanRoute = "/api/pravachans?lang=";
  categoryRoute = "/api/settings/filters?lang=";
  pravachanAuthorCount = "/api/Pravachans/AuthorCount?lang=";
  pravachanCategoryRoute = "/api/Pravachans/Categories?lang=";
  recordCountRoute = "/api/Settings/FilterRecordCount";
  pravachanByIdPath = "/api/Pravachans/";

  GetAuthorDataById(idOrSlug: string) {
    const logdetails: string[] = [];
    logdetails.push("action=GetAuthorDataById");
    logdetails.push(`idOrSlug=${idOrSlug || ""}`);

    // Special (1) and Other (0) are list-filter buckets, not author documents
    if (idOrSlug === "0" || idOrSlug === "1" || idOrSlug === "slug-0" || idOrSlug === "slug-1") {
      logdetails.push("skipped=special_or_other_filter");
      console.log("PravachansService ->", logdetails.join(" | "));
      return Promise.resolve({ status: false, result: null });
    }

    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    logdetails.push(`identifier=${identifier}`);
    console.log("PravachansService ->", logdetails.join(" | "));
    return ApiUtility.get(
      `/api/Pravachans/Authors/${identifier}?lang=` + localStorage.getItem("lan")
    );
  }

  /** Resolve pravachan category by Mongo id or slug (same identifier rule as books). */
  GetCategoryDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/Pravachans/Categories/${identifier}?lang=` + localStorage.getItem("lan")
    );
  }

  /** Language metadata — shared /api/languages endpoint used by books. */
  GetLanguageDataById(id: string) {
    return ApiUtility.get(
      "/api/languages/" + id + "?lang=" + localStorage.getItem("lan")
    );
  }

  getFilters = (lang: string, productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute + lang + "&productFor=" + productFor
    );
  };

  /**
   * Cascading pravachan date filter — POST /api/Pravachans/getFilter
   * year=9999 → years with records; year+month=0 → months; year+month+date=0 → days
   * Optional authorId scopes years/months/days to a specific preacher (Mongo id only).
   */
  getPravachanFilter = async (
    year: number,
    month: number,
    date: number = 0,
    authorId?: string
  ) => {
    const logdetails: string[] = [];
    logdetails.push(`trigger=getPravachanFilter year=${year} month=${month} date=${date}`);

    // Only real Mongo author ids — skip empty, Special (1), and Other (0) filter buckets
    const isMongoAuthorId = /^[0-9a-fA-F]{24}$/.test(String(authorId ?? ""));
    const payload: { year: number; month: number; date: number; authorId?: string } = {
      year,
      month,
      date,
    };
    if (isMongoAuthorId && authorId) {
      payload.authorId = authorId;
      logdetails.push(`authorId=${authorId}`);
    }

    const response = await ApiUtility.post(
      "/api/Pravachans/getFilter",
      payload,
      "application/json"
    );

    if (response?.status && Array.isArray(response.result)) {
      const normalized = response.result
        .map((item: any) => Number(item))
        .filter((n: number) => !Number.isNaN(n));
      logdetails.push(`status=success count=${normalized.length}`);
      console.log("PravachansService.getPravachanFilter ->", logdetails.join(" | "));
      return { ...response, result: normalized };
    }

    logdetails.push("status=failed_or_empty");
    console.log("PravachansService.getPravachanFilter ->", logdetails.join(" | "));
    return response;
  };

  getPravachans = (
    lang: string,
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean,
    month: string,
    year: string
  ) => {
    return ApiUtility.get(
      this.pravachanRoute +
        lang +
        "&start=" +
        start +
        "&length=" +
        length +
        "&categoryId=" +
        categoryId +
        "&IsChildLiterature=" +
        IsChildLiterature +
        "&authorId=5bbc60101fd2d735b0087d36" +
        "&search=" +
        search +
        "&sort=" +
        sort +
        "&bookLangauge=" +
        langId +
        "&isSpecial=" +
        isSpecial +
        "&month=" +
        month +
        "&year=" +
        year
    );
  };

  getMobilePravachanCategory = (lang?: string) => {
    return ApiUtility.get(this.pravachanCategoryRoute + lang);
  };

  getMobilePravachanAuthorCount = (lang?: string) => {
    return ApiUtility.get(this.pravachanAuthorCount + lang);
  };

  getPravachanAuthorCount = (lang?: string) => {
    return ApiUtility.get(this.pravachanAuthorCount + lang);
  };

  getMobileRecordCount = (
    filterfor: string,
    productFor: string,
    categoryId?: string,
    language?: string,
    authorId?: string,
    subjectId?: string
  ) => {
    let url =
      this.recordCountRoute +
      "?filterfor=" +
      filterfor +
      "&productFor=" +
      productFor;
    if (categoryId) url += "&categoryId=" + categoryId;
    if (language) url += "&language=" + language;
    if (authorId) url += "&authorId=" + authorId;
    if (subjectId) url += "&subjectId=" + subjectId;
    return ApiUtility.get(url);
  };

  getMobilePravachanById = (id: string, lang?: string, userId?: string) => {
    let url = this.pravachanByIdPath + id + "?lang=" + lang;
    if (userId) {
      url += "&userId=" + userId;
    }
    return ApiUtility.get(url);
  };

  getRecordCount = (
    filterfor: string,
    productFor: string,
    categoryId?: string,
    language?: string,
    authorId?: string,
    subjectId?: string
  ) => {
    let url =
      this.recordCountRoute +
      "?filterfor=" +
      filterfor +
      "&productFor=" +
      productFor;
    if (categoryId) url += "&categoryId=" + categoryId;
    if (language) url += "&language=" + language;
    if (authorId) url += "&authorId=" + authorId;
    if (subjectId) url += "&subjectId=" + subjectId;
    return ApiUtility.get(url);
  };
}
export default new PravachansService();
